export const SettingPage = () => {
  return <p>Тут будет страница настройки</p>;
};
